'use es6';

import _count from './internal/_count';
/**
 * Returns the number of values in `subject`.
 *
 * @example
 * count(List.of(1, 2, 3)) === 3;
 *
 * @param {TYPE} subject
 * @return {number}
 */

export default _count;